/**
 * Распознавание ответа «сначала чат с Падлой» — один источник правды на все входы (П9).
 *
 * Сервер отвечает на авторизацию `403 {ok:false, error:'no_dialog', bot_url}` тому, у кого
 * нет личного диалога с ботом (решение ректора 08.08.2026). Четыре шелла — кабинет,
 * астрология, песни, тесты — обязаны понять это одинаково: иначе один покажет экран
 * знакомства, а другой — «Не открылось» с непонятным словом внутри.
 */

export interface NoDialogEntry {
  /** Дверь в переписку: построена сервером, уже несёт намерение человека. */
  botUrl: string;
  /** Каким текстом объяснять: 'pair' — человека позвал друг на совместимость. */
  variant: 'default' | 'pair';
}

/** Виды приглашения, где человек пришёл ЗА ОТВЕТОМ О ПАРЕ (текст стены другой). */
const PAIR_START_PREFIXES = ['synastry_', 'pair_', 'astrocompat_', 'pairview_'];

/**
 * Вариант текста по параметру входа. Читаем ровно тот же `start_param`, что панель уже
 * использует для маршрутизации (initDataUnsafe) — без него человек, позванный на
 * совместимость, увидел бы общий текст и не понял, при чём тут переписка.
 */
export function meetWallVariant(startParam?: string | null): 'default' | 'pair' {
  const sp =
    typeof startParam === 'string'
      ? startParam
      : ((
          window as unknown as {
            Telegram?: { WebApp?: { initDataUnsafe?: { start_param?: string } } };
          }
        ).Telegram?.WebApp?.initDataUnsafe?.start_param ?? '');
  return PAIR_START_PREFIXES.some((p) => sp.startsWith(p)) ? 'pair' : 'default';
}

/**
 * Ответ авторизации — это «иди сначала в переписку»? Возвращает данные для экрана либо
 * null (значит отказ обычный: бан, битый initData, сбой — их обрабатывают как раньше).
 */
export function parseNoDialogResponse(status: number, body: unknown): NoDialogEntry | null {
  if (status !== 403) return null;
  const b = (body ?? {}) as { error?: unknown; bot_url?: unknown };
  if (b.error !== 'no_dialog') return null;
  // Ссылку берём ТОЛЬКО у сервера: имя бота и форма двери живут в одном месте
  // (buildBotChatUrl). Нет ссылки — экран бессмыслен, отдаём обычный путь ошибки.
  if (typeof b.bot_url !== 'string' || b.bot_url.length === 0) return null;
  return { botUrl: b.bot_url, variant: meetWallVariant() };
}
